



































import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import { ReportPhoto } from '@/models/report'
import { Lov } from '@/models/lov'
import SelectPhoto from '@/components/SelectPhoto.vue'
import LovSelect from '@/components/LovSelect.vue'

// Service
import { Datasource } from '@/services/datasource'

@Component({
  components: {
    SelectPhoto,
    LovSelect
  }
})
export default class ReportPhotos extends Vue {

  @Prop({ default: [] })
  public value: ReportPhoto[]

  @Prop()
  public reportId!: string

  @Prop({ default: [] })
  public photoCaptions: Lov[]

  private addPhoto() {
    // Add new one & Emit to input
    this.input(this.value.concat([new ReportPhoto()]))
  }

  private onUrlImageChanged(index: number, newUrl: string) {
    const newVal: ReportPhoto[] = (new Array<ReportPhoto>()).concat(this.value)
    const newPhoto = new ReportPhoto()
    newPhoto.caption = newVal[index].caption
    newPhoto.url = newUrl
    newVal[index] = newPhoto
    this.input(newVal)
  }

  public async uploadIfNeeded(): Promise<boolean> {
    // perform upload to all items
    console.group('User request uploads for report', this.reportId)
    // Loop through and convert each value from 'data' => 'url'

    // Get all those with data url
    let toUploads: {photo: ReportPhoto, index: number}[] = this.value
      .map((photo, index) => ({ photo, index }))
      .filter((o) => o.photo.isDataUrl)
    console.log('Prepare for uploads', toUploads)

    // There is nothing to do
    if (toUploads.length === 0) {
      console.log('No content to upload')
      console.groupEnd()
      return Promise.resolve(true)
    }
    
    // Start converting one by one
    let dataUriToBlob = async (base64: string): Promise<Blob> => {
      console.log(`Converting URI: ${base64} to blob`)
      return fetch(base64).then((res:Response) => res.blob())
    }

    // convert base64/image to Blob
    const buffer: Blob[] = []
    for(let i in toUploads) {
      buffer[i] = await dataUriToBlob(toUploads[i].photo.url)
    }
    
    // Upload all blob to server
    console.log('Perform upload photos', toUploads, buffer)
    const uploaded = await Datasource.shared.uploadPhotos(`reports/${this.reportId}`, buffer)

    // Patch returned URLS to respective object.v
    console.groupCollapsed('Patch upload results to photo object')
    for(let i in uploaded) {
      const { index } = toUploads[i]
      console.log('At', index, 'From', toUploads[i], '=>', uploaded[i])
      this.value[index].url = uploaded[i]
    }
    console.log('Result', this.value)
    console.groupEnd()

    // Emit input changes for the updated result.
    console.log('Dispatch Result')
    this.input(this.value)
    console.groupEnd()
    return true
  }

  private deletePhoto(index: number) {
    // Remove item
    this.value.splice(index, 1)
    // Dispatch input
    this.input(this.value)
  }

  @Emit('input')
  public input(photos: ReportPhoto[]) { }

}
